import axios from "axios";
import getAxiosConfig from "./getAxiosConfig";

export const getUpcomingClassesService = async (limit, offset) => {
  return await axios({
    ...getAxiosConfig(
      'GET',
      () => `/v2/course/live/student/upcoming?limit=${limit}&offset=${offset}&viewAll=1`,
      {}
    ),
  });
};